import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useSessionStore } from '@/stores/session'
import { resolveSelectionFromRoute, resolveHomeTarget } from '@/utils/sessionScenario'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/scenarios',
    name: 'scenarios',
    component: () => import('@/views/ScenarioListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/scenarios/:id',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/scenarios/:id/finance',
    name: 'finance',
    component: () => import('@/views/FinanceView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/scenarios/:id/vehicles/:vehicleId',
    name: 'vehicle-detail',
    component: () => import('@/views/VehicleDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/scenarios/:id/company',
    name: 'company',
    component: () => import('@/views/CompanyView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/scenarios/:id/notifications',
    name: 'notifications',
    component: () => import('@/views/NotificationsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/scenarios/:id/audit',
    name: 'admin-audit',
    component: () => import('@/views/AdminAuditView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/tokens',
    name: 'admin-tokens',
    component: () => import('@/views/AdminTokensView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/auth/callback',
    name: 'auth-callback',
    component: () => import('@/views/AuthCallbackView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth) {
    const auth = useAuthStore()
    if (!auth.isAuthenticated) {
      await auth.silentRenew()
    }
    if (!auth.isAuthenticated) {
      auth.login(to.fullPath)
      return false
    }
  }

  // Lock the session: an authenticated visit to the marketing home page
  // returns to the selected game's dashboard instead (issue 410).
  if (to.name === 'home') {
    const auth = useAuthStore()
    if (auth.isAuthenticated) {
      const target = resolveHomeTarget(useSessionStore().selectedId)
      if (target !== '/') return target
    }
  }
})

router.afterEach((to) => {
  const id = resolveSelectionFromRoute(to)
  if (id) useSessionStore().select(id)
})

export default router
